import { downgradeComponent } from "@angular/upgrade/static";
import { ManageRequisitionEntitiesPageComponent } from './manage-requisition-entities-page.component';

export const ManageRequisitionEntitiesAjsPageModule = angular
  .module('requisitionEntitiesPage', [])
  .directive('requisitionEntitiesPage', downgradeComponent({ component: ManageRequisitionEntitiesPageComponent }))
  .config(
    ['$stateProvider', ($stateProvider) => {
      $stateProvider.state('missioncontrol.requisitionEntities', {
        url: '/requisitionEntities',
        component: ManageRequisitionEntitiesPageComponent,
        data: {
          requireLogin: true
        }
      });
    }
    ])
  .name;
